import React from 'react';
import Radium from 'radium';
import { string } from 'prop-types';
import { UTLabel } from '@widergy/energy-ui';

import Images from 'config/assets';
import { message } from 'utils/stringUtils';

import stylesJS from './styles';
import styles from './styles.module.scss';

const AuthFormBox = ({ children, title }) => (
  <React.Fragment>
    <img src={Images.authFormWrapper} alt={message('Translation:avatar')} className={styles.avatar} />
    <div style={stylesJS.formContainer}>
      <UTLabel large semibold className={styles.title} style={stylesJS.title}>
        {title}
      </UTLabel>
      {children}
    </div>
  </React.Fragment>
);

AuthFormBox.propTypes = {
  title: string.isRequired
};

export default Radium(AuthFormBox);
